var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockBackHistoryFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.2 22q-3.5 0-6.194-2.125t-3.5-5.43a.82.82 0 0 1 .166-.764q.278-.348.75-.403.444-.056.806.166.36.222.5.667.665 2.5 2.75 4.083 2.083 1.584 4.722 1.584 3.25 0 5.514-2.264T19.978 12t-2.264-5.514T12.2 4.222a7.5 7.5 0 0 0-3.583.89A8.26 8.26 0 0 0 5.81 7.555h1.945q.471 0 .791.319.32.32.32.792 0 .471-.32.791t-.791.32H3.31q-.472 0-.792-.32a1.08 1.08 0 0 1-.32-.791V4.222q.001-.472.32-.791.32-.32.792-.32t.792.32.32.791v1.5a9.7 9.7 0 0 1 3.458-2.75A9.9 9.9 0 0 1 12.2 2q2.083 0 3.903.792a10.2 10.2 0 0 1 3.166 2.139 10.2 10.2 0 0 1 2.14 3.166A9.7 9.7 0 0 1 22.2 12q0 2.084-.792 3.903a10.2 10.2 0 0 1-2.139 3.166 10.2 10.2 0 0 1-3.166 2.14A9.7 9.7 0 0 1 12.2 22m1.111-10.444 2.778 2.777q.306.306.305.778 0 .472-.305.778a1.05 1.05 0 0 1-.778.305q-.472 0-.778-.305l-3.11-3.111a1.1 1.1 0 0 1-.25-.375 1.2 1.2 0 0 1-.084-.43V7.555q0-.473.32-.792.318-.32.791-.32t.792.32q.32.32.32.792z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBackHistoryFill);
export default __webpack_public_path__ + "static/media/clock_back_history_fill.85dace0faa458dbba3b5b7573db07fe6.svg";
export { ForwardRef as ReactComponent };